export default "__VITE_ASSET__B7AR8WEJ__"